import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "@env/environment";
import { TranslateService } from "@ngx-translate/core";

@Pipe({ name: "getProgress", standalone: false })
export class GetProgress implements PipeTransform {
  transform(progress: any): string {
    return progress.avance + "%";
  }
}

@Pipe({ name: "urlImage", standalone: false })
export class UrlImage implements PipeTransform {
  transform(item: any, type: number): string {
    let url = "https://d3puay5pkxu9s4.cloudfront.net/Users/";
    if (type == 0) {
      // Formato normal
      if (item.sender.image.includes("platform-lookaside.fbsbx.com")) {
        url += "default/small_imagen.jpg";
      } else {
        if (
          item.sender.fuente == "facebook" ||
          item.sender.fuente == "google"
        ) {
          if (item.sender.image != "") {
            if (item.sender.image.substring(0, 4) == "http") {
              url = item.sender.image;
            } else {
              url += item.sender.id + "/small_" + item.sender.image;
            }
          } else {
            url += "default/small_imagen.jpg";
          }
        } else if (item.sender.image == "") {
          url += "default/small_imagen.jpg";
        } else {
          url += item.sender.id + "/small_" + item.sender.image;
        }
      }
    } else if (type == 1) {
      // Formato mapeado
      if (item.associated.length === 1) {
        if (
          item.associated[0].user.user_fuente == "facebook" ||
          item.associated[0].user.user_fuente.S == "google"
        ) {
          if (item.associated[0].user.user_image != "") {
            if (item.associated[0].user.user_image.substring(0, 4) == "http") {
              url = item.associated[0].user.user_image;
            } else {
              url +=
                item.associated[0].user.user_id +
                "/small_" +
                item.associated[0].user.user_image;
            }
          } else {
            url += "default/small_imagen.jpg";
          }
        } else if (item.associated[0].user.user_image == "") {
          url += "default/small_imagen.jpg";
        } else {
          url +=
            item.associated[0].user.user_id +
            "/small_" +
            item.associated[0].user.user_image;
        }
      } else {
        if (item.conversation.image == "") {
          url += "default/small_imagen.jpg";
        } else {
          url += item.conversation.id + "/Image/" + item.conversation.image;
        }
      }
    } else if (type == 2) {
      // Formato cursos
      if (item.User.fuente == "facebook" || item.User.fuente == "google") {
        if (item.User.image != "") {
          if (item.User.image.substring(0, 4) == "http") {
            url = item.User.image;
          } else {
            url += item.User.id + "/small_" + item.User.image;
          }
        } else {
          url += "default/small_imagen.jpg";
        }
      } else if (item.User.image == "") {
        url += "default/small_imagen.jpg";
      } else {
        url += item.User.id + "/small_" + item.User.image;
      }
    } else if (type == 3) {
      // Formato mapeado lambda
      if (item.associated.length > 0) {
        if (
          item.associated[0].user.user_fuente == "facebook" ||
          item.associated[0].user.user_fuente == "google"
        ) {
          if (item.associated[0].user.user_image != "") {
            if (item.associated[0].user.user_image.substring(0, 4) == "http") {
              url = item.associated[0].user.user_image;
            } else {
              url +=
                item.associated[0].user.user_id +
                "/small_" +
                item.associated[0].user.user_image;
            }
          } else {
            url += "default/small_imagen.jpg";
          }
        } else if (item.associated[0].user.user_image == "") {
          url += "default/small_imagen.jpg";
        } else {
          url +=
            item.associated[0].user.user_id +
            "/small_" +
            item.associated[0].user.user_image;
        }
      } else {
        if (item.conversation.image == "") {
          url += "default/small_imagen.jpg";
        } else {
          url += item.conversation.image
            ? item.conversation.id + "/Image/" + item.conversation.image
            : "default/small_imagen.jpg";
        }
      }
    } else if (type == 4) {
      // Usuario de chat
      if (item.user) {
        if (
          item.user.user_fuente == "facebook" ||
          item.user.user_fuente == "google"
        ) {
          if (item.user.user_image != "") {
            if (item.user.user_image.substring(0, 4) == "http") {
              url = item.user.user_image;
            } else {
              url += item.user.user_id + "/small_" + item.user.user_image;
            }
          } else {
            url += "default/small_imagen.jpg";
          }
        } else if (item.user.user_image == "") {
          url += "default/small_imagen.jpg";
        } else {
          url += item.user.user_id + "/small_" + item.user.user_image;
        }
      } else {
        url += "default/small_imagen.jpg";
      }
    } else if (type == 5) {
      if (item) {
        let imageUrl = null;

        if (item.image) {
          try {
            // Si el valor parece un JSON (comienza con { y termina con })
            if (
              typeof item.image === "string" &&
              item.image.trim().startsWith("{")
            ) {
              const parsed = JSON.parse(item.image);
              imageUrl = parsed?.data?.url || null;
            } else if (item.image.substring(0, 4) === "http") {
              imageUrl = item.image;
            } else if (item.image !== "") {
              imageUrl = url + item.id + "/small_" + item.image;
            }
          } catch (error) {
            // Si falla el parseo, usamos imagen por defecto
            imageUrl = url + "default/small_imagen.jpg";
          }
        }

        // Si no se logró obtener una imagen válida, usamos la por defecto
        if (!imageUrl) {
          imageUrl = url + "default/small_imagen.jpg";
        }

        url = imageUrl;
      }
    }

    return url;
  }
}

@Pipe({ name: "roleName", standalone: false, pure: false })
export class RoleName implements PipeTransform {
  constructor(private _translate: TranslateService) {}
  transform(role: string): string {
    switch (role.toLocaleLowerCase()) {
      case "free":
        return this._translate.instant("ROLES.FREE");
      case "premium":
        return this._translate.instant("ROLES.PREMIUM");
      case "propietario":
      case "professor":
        return this._translate.instant("ROLES.PROFESSOR");
      case "moderador":
      case "monitor":
        return this._translate.instant("ROLES.MONITOR");
      case "administrator":
        return this._translate.instant("ROLES.ADMINISTRATOR");
      case "assistant":
      case "assistant_professor":
        return this._translate.instant("ROLES.ASSISTANT_PROFESSOR");
      default:
        return role;
    }
  }
}

@Pipe({ name: "userClassName", standalone: false })
export class UserClassName implements PipeTransform {
  transform(role: string): string {
    switch (role.toLocaleLowerCase()) {
      case "free":
        return "student-free";
      case "premium":
        return "student-official";
      case "monitor":
        return "monitor";
      case "propietario":
      case "professor":
        return "teacher";
      case "moderador":
      case "assistant":
      case "administrator":
      case "assistant_professor":
        return "moderador";
    }
  }
}

@Pipe({ name: "cutUserName", standalone: false })
export class CutUserNamePipe implements PipeTransform {
  transform(username: string, length: string): string {
    username = username ? username : "";
    username = username.toLocaleLowerCase();

    let split_username_length = username.trim().split(/\s+/).length;
    var un = username.split(" ");
    switch (length) {
      case "1":
        var user_name = un[0];
        break;
      case "2":
        var user_name =
          split_username_length < 3
            ? username
            : split_username_length == 3
            ? un[0] + " " + un[1]
            : un[0] + " " + un[2];
        break;
    }
    let name = "";

    user_name.split(" ").forEach((U) => {
      name += U.charAt(0).toUpperCase() + U.slice(1) + " ";
    });

    return name;
  }
}
@Pipe({ name: "shoppingCarType", standalone: false })
export class shoppingCarType implements PipeTransform {
  transform(type: number): string {
    switch (type) {
      case 1:
        return "Certificado de estudios";
      case 2:
        return "Carrera online";
    }
  }
}

@Pipe({ name: "notificationsDate", standalone: false, pure: false })
export class notificationsDate implements PipeTransform {
  constructor(private _translate: TranslateService) {}
  transform(_date: string): string {
    var today: any = new Date();
    var yesterday = "";
    var dd = String(today.getDate()).padStart(2, "0");
    var dd1 = String(today.getDate() - 1).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    yesterday = yyyy + "-" + mm + "-" + dd1;

    if (_date.substring(0, 10) == today) {
      return this._translate.instant("DATES.TODAY_LABEL");
    } else if (_date.substring(0, 10) == yesterday) {
      return this._translate.instant("DATES.YESTERDAY_LABEL");
    } else {
      var monthNames = this._translate.instant("DATES.MONTHS_SHORT").split(",");
      return (
        parseInt(_date.substring(8, 10)) +
        " " +
        monthNames[parseInt(_date.substring(5, 7)) - 1]
      );
    }
  }
}

@Pipe({ name: "messageDate", standalone: false, pure: false })
export class messageDate implements PipeTransform {
  constructor(private _translate: TranslateService) {}
  transform(_date: string): string {
    var today: any = new Date();
    var yesterday = "";
    var dd = String(today.getDate()).padStart(2, "0");
    var dd1 = String(today.getDate() - 1).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = yyyy + "-" + mm + "-" + dd;
    yesterday = yyyy + "-" + mm + "-" + dd1;

    if (_date.substring(0, 10) == today) {
      return this._translate.instant("DATES.TODAY_LABEL");
    } else if (_date.substring(0, 10) == yesterday) {
      return this._translate.instant("DATES.YESTERDAY_LABEL");
    } else {
      var monthNames = this._translate.instant("DATES.MONTHS_SHORT").split(",");

      return (
        parseInt(_date.substring(8, 10)) +
        " " +
        monthNames[parseInt(_date.substring(5, 7)) - 1]
      );
    }
  }
}

@Pipe({ name: "categoryName", standalone: false })
export class categoryName implements PipeTransform {
  transform(categoryid: any, categories: any): string {
    if (categoryid && categories) {
      let result = categories.find((category) => category.id == categoryid);
      return result ? result.name : "";
    }
    return "";
  }
}

@Pipe({ name: "cssChildHeight", standalone: false })
export class CssChildHeight implements PipeTransform {
  transform(elemt: any): number {
    const child = elemt.children[0];
    return parseFloat(
      window.getComputedStyle(child).getPropertyValue("height")
    );
  }
}

@Pipe({ name: "courseConfigUrl", standalone: false })
export class CourseConfigUrl implements PipeTransform {
  transform(course: any, user_id): string {
    let config = {
      curso_id: course.id,
      certification_id: course.certification_id,
      type: course.tipo,
      clase_id: course.clase_id != "" ? course.clase_id : 0,
      idu: user_id,
      source_id: course.source_id != "" ? course.source_id : 0,
      quiz_id: course.quiz_id != "" ? course.quiz_id : 0,
      language_id: course.language_id,
      state: course.certification_state,
      tour:
        course.certification_tour != null ? course.certification_tour : "-1",
    };

    // let url = 'https://apptemp.edutin.com/classroom?config=' + JSON.stringify(config)
    let url =
      environment.domain + "/classroom?config=" + JSON.stringify(config);

    return url;
  }
}

@Pipe({ name: "groupNamePipe", standalone: false })
export class GroupNamePipe implements PipeTransform {
  transform(conversation): string {
    let name = "";

    const user_name = (user) => {
      user = user.split(" ")[0];
      return user.charAt(0).toUpperCase() + user.slice(1);
    };

    if (conversation && conversation.associated.length == 1) {
      name = conversation.associated[0].user.user_name;
    } else if (conversation && conversation.associated.length > 0) {
      if (conversation.associated.length === 2) {
        name =
          user_name(conversation.associated[0].user.user_name) +
          " y " +
          user_name(conversation.associated[1].user.user_name);
      } else {
        name =
          user_name(conversation.associated[0].user.user_name) +
          ", " +
          user_name(conversation.associated[1].user.user_name) +
          " y " +
          (conversation.associated.length - 2).toString() +
          " más";
      }
    }

    return name;
  }
}

@Pipe({
  name: "imageUrlPipe",
  standalone: false,
})
export class ImageUrlPipe implements PipeTransform {
  transform(src: any, size: string = "small"): string {
    // Verificar si src es un enlace directo a la imagen
    if (src.image) {
      if (src.image.startsWith("http") || src.image.startsWith("https")) {
        return src.image;
      }
    }

    // Verificar si src es un objeto con id e image
    if (src && src.id && src.image) {
      const baseUrl = "https://d3puay5pkxu9s4.cloudfront.net/Users/";
      const imageSize = size === "very-large" ? "medium_" : "small_";
      return `${baseUrl}${src.id}/${imageSize}${src.image}`;
    }

    // Si no se cumple ninguna de las condiciones anteriores, devolver una URL por defecto o un valor nulo según tus necesidades.
    // Por ejemplo:
    // return 'URL_POR_DEFECTO';
    // return null;

    // En este ejemplo, se devuelve una URL de imagen por defecto si no se cumple ninguna condición.
    return "https://d3puay5pkxu9s4.cloudfront.net/Users/default/small_imagen.jpg";
  }
}

@Pipe({ name: "getCategoryLogoPipe", standalone: true })
export class GetCategoryLogoPipe implements PipeTransform {
  transform(category_id: any, campaings: any[]): string {
    let campaing = campaings.find((c) => {
      return c.Category?.id.toString() == category_id;
    });
    return campaing?.Category?.logo;
  }
}

@Pipe({
  name: "parseNamePipe",
  standalone: true,
})
export class ParseNamePipe implements PipeTransform {
  transform(name: string): string {
    if (!name) return "";
    //check if name has spaces
    if (name.includes(" ")) {
      //remove spaces
      name = name.replace(/\s+/g, " ");
    }

    return name;
  }
}

@Pipe({
  name: "usdAbbreviation",
  standalone: true,
})
export class UsdAbbreviationPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) return "0 USD";

    const abs = Math.abs(value);

    if (abs >= 1_000_000_000) {
      return `${(value / 1_000_000_000).toFixed(1).replace(/\.0$/, "")}B USD`;
    } else if (abs >= 1_000_000) {
      return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, "")}M USD`;
    } else if (abs >= 1_000) {
      return `${(value / 1_000).toFixed(1).replace(/\.0$/, "")}K USD`;
    } else {
      return `${value.toFixed(0)} USD`;
    }
  }
}

@Pipe({
  name: "currencyShortUsd",
  standalone: true,
})
export class CurrencyShortUsdPipe implements PipeTransform {
  transform(value: number | string, hasSigns: boolean = false): string {
    if (value === null || value === undefined || value === "") return "$0";

    let num: number;
    let isNegative = false;

    if (typeof value === "string") {
      if (value.includes("-")) {
        isNegative = true;
      }

      num = Number(value.replace(/[+-]/g, ""));
    } else {
      num = value;
      isNegative = num < 0;
      num = Math.abs(num);
    }

    if (isNaN(num)) return "$0";

    // const symbol = "$";
    const prefix = isNegative ? "-" : hasSigns ? "+" : "";

    let formatted: string;

    if (num >= 1_000_000_000) {
      formatted = (num / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (num >= 1_000_000) {
      formatted = (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (num >= 1_000) {
      formatted = (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      formatted = num.toString();
    }

    return `${prefix}${formatted}`;
  }
}


/**** BLOCK EDITOR PIPES ****/
@Pipe({
  name: "iconClassPipe",
})
export class IconClassPipe implements PipeTransform {
  transform(value: string): string {
    let word = ["doc", "docx"];
    let excel = ["xls", "xlsx", "csv"];
    let ppt = ["ppt", "pptx"];
    let image = ["png", "jpg", "jpeg", "gif", "svg", "bmp", "tiff", "webp"];
    let video = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];
    let audio = ["mp3", "wav", "aac", "flac", "ogg"];
    let pdf = ["pdf"];

    if (!value || typeof value !== "string" || !value.includes(".")) {
      return "icon-file";
    }

    let extension = value.split(".").pop()?.toLowerCase();
    if (!extension) return "icon-file";

    if (word.includes(extension)) {
      return "icon-microsoftword";
    } else if (excel.includes(extension)) {
      return "icon-microsoftexcel";
    } else if (ppt.includes(extension)) {
      return "icon-powerpoint";
    } else if (image.includes(extension)) {
      return "icon-image";
    } else if (video.includes(extension)) {
      return "icon-cam";
    } else if (audio.includes(extension)) {
      return "icon-music-note";
    } else if (pdf.includes(extension)) {
      return "icon-pdf-file";
    } else {
      return "icon-file";
    }
  }
}